import http from './http';

export default function getProfileInfo(verificationId) {
  return http.get(`/services/workflows/ansys/profile`, {
    params: { verificationId }
  });
}